import { apiNodeRequest } from '@/store/core/main'

const STORAGE_KEY = 'happily-townhall-reels-v1'

const localMode = () => process.env.NODE_ENV !== 'production' && process.env.VUE_APP_REEL_API_URL !== 'remote'

function readLocalReels() {
  if (typeof window === 'undefined') return []
  try {
    const value = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]')
    return Array.isArray(value) ? value : []
  } catch (_) {
    return []
  }
}

function reelDuration(item) {
  if (!item) return 0
  if (item.source === 'upload') return Number((item.uploadedVideo || {}).durationSec) || 0
  return (item.scenes || []).reduce((total, scene) => total + (Number(scene && scene.durationSec) || 0), 0)
}

function formatDuration(seconds) {
  const total = Math.max(0, Math.round(Number(seconds) || 0))
  if (!total) return ''
  if (total < 60) return `${total} sec`
  const minutes = Math.floor(total / 60)
  const remainder = total % 60
  return remainder ? `${minutes} min ${remainder} sec` : `${minutes} min`
}

export function buildProgramReelLibrary(reels) {
  return (Array.isArray(reels) ? reels : [])
    .filter((item) => {
      if (!item || item.archived || item.deleted) return false
      if (item.publicationStatus !== 'published') return false
      // A newly published builder reel may still be rendering. It becomes
      // selectable once the API marks it ready, preventing a Program from
      // pointing participants at a video that cannot play yet.
      return item.renderStatus === 'ready' || (!item.renderStatus && Boolean(
        item.videoUrl || (item.uploadedVideo && item.uploadedVideo.url)
      ))
    })
    .map((item) => {
      const duration = formatDuration(reelDuration(item))
      const caption = String(item.caption || '').trim()
      const meta = [duration, caption].filter(Boolean).join(' · ')
      return {
        id: item.id || item.key,
        title: String(item.title || '').trim(),
        meta,
        search: [item.title, item.caption, ...(Array.isArray(item.tags) ? item.tags : []), duration]
          .filter(Boolean)
          .join(' ')
          .toLowerCase(),
      }
    })
    .filter((item) => item.id && item.title)
}

export async function loadProgramReels() {
  if (localMode()) return readLocalReels()
  const prefix = process.env.VUE_APP_REEL_API_URL || 'https://us-central1-people2-admin.cloudfunctions.net/townhallReelsApi/v1/reels'
  const response = await apiNodeRequest({ method: 'GET', url: prefix })
  const payload = response && response.data
  return Array.isArray(payload) ? payload : []
}
